<template>
    <div>
        <buttonlist ref="SetBtn" @help="help" @opentable="opentable" @search="search" @exps="exps"></buttonlist>
        <div style="width:100%">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[1974]') }}</td>
                    <td style="width:150px;">
                        <el-select filterable v-model="costyear"  size="mini" style="margin-righ:20px">
                            <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </td>
                    <td style="width:60px">{{ $t('getapi[1975]') }}</td>
                    <td style="width:150px;">
                        <el-select filterable v-model="costmonth"  size="mini" style="margin-righ:20px">
                            <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </td>
                </tr>
            </table>
            <div id="xpane-0">
            <vTable
                    :data="dataSet"
                    :loading="loading"
                    queryData="3_wipsum"
                    :filter_language="['so_status_name']"
                    :filter_thousandth="['sum_material','sum_man','sum_charge','sum_charge_material','sum_carry_man','sum_carry_charge']"
                    :height="tableHeight"
                    :header="tableHeader"
                    :option="tableOption"
                    ref="singleTable"
                    :checkflg="false"
            ></vTable>
            </div>
           <!-- <vxe-table
                    :data="dataSet"
                    ref="singleTable"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <vxe-table-column type="selection" v-if="false"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="so_code" :title="$t('getapi[4168]')"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="schedule_no" :title="$t('getapi[4209]')"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="create_time" :title="$t('getapi[1420]')"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="so_status_name" :title="$t('getapi[7521]')"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="item_code" :title="$t('getapi[6211]')"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="sum_material" :title="$t('getapi[7522]')" align="right"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="sum_man" :title="$t('getapi[7523]')" align="right"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="sum_charge" :title="$t('getapi[7524]')" align="right"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="sum_charge_material" :title="$t('getapi[7525]')" align="right"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="sum_carry_man" :title="$t('getapi[7526]')" align="right"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="sum_carry_charge" :title="$t('getapi[7527]')" align="right"></vxe-table-column>
            </vxe-table>-->
        </div>

        <ctable :isVisible="false" :title="$t('getapi[6669]')" queryData="3_wipsum" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_wipsum',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight2,
                    maxHeight: this.$windowSize.tableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                costyear: '',
                costmonth: '',
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                yearList: [],
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            let year = new Date().getFullYear()
            that.yearList.push({
                value: year + 1,
                label: year + 1
            })
            for(let i=0;i<10;i++){
                that.yearList = [...that.yearList,{
                    value: year - i,
                    label: year - i
                }]
            }
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('3_wipsum',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6669]"),this.$t("getapi[6633]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('search,export');
            },
            getView(){
                let that = this
                let parm = {
                    costyear: that.costyear,
                    costmonth: that.costmonth
                }
                that.loading = true;
                that.$http.urlpost('/Fin/Wip/GetWipSumView', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                    }
                    that.loading = false;
                });
            },
            search(){
                let that = this
                that.getView()
            },
            exps(){
                let that = this;
                that.loading = true;
                let parm = {
                    costyear: that.costyear,
                    costmonth: that.costmonth
                }
                that.$http.urlpost('/Fin/Wip/GetWIPSumViewToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
